<template>
    <div>
        <div class="row">

            <h1 class="page-header">{{ pageTitle }}

            <span class="pull-right">
                <button v-on:click="createNewTrainingSet" class="btn btn-primary" v-show="!showForm">Add New Training Set</button>
                <button v-on:click="saveTrainingSet" class="btn btn-success" v-show="showForm">Save Training Set</button>
            </span>
            </h1>
        </div>

        <div class="row">
            <training-set-form v-on:training-set-updated="finishEditing" v-show="showForm" ref="trainingSetForm"></training-set-form>
        </div>

        <training-set-list v-on:edit-training-set="editTrainingSet" ref="trainingSetList"></training-set-list>
    </div>
</template>


<script>
    export default {
        props: {
            // HTML is case insensitive. Vue converts kebab-case HTML props to camel-case
            // So in HTML this is page-title
            pageTitle: {
                type: String,
                default: 'Training Sets'
            }
        },
        data: function () {
            return {
                showForm: false,
            }
        },
        computed: {
        },
        mounted() {
            this.debug('component mounted.');
        },
        methods: {
            editTrainingSet(training_set_id, training_set) {
                this.debug('editTrainingSet()');
                this.$refs.trainingSetForm.setTrainingSetData(training_set_id, training_set);
                this.showForm = true;
            },
            createNewTrainingSet() {
                this.debug('createNewTrainingSet()');
                this.$refs.trainingSetForm.loadEmptyTrainingSet();
                this.showForm = true;
            },
            saveTrainingSet() {
                this.debug('saveTrainingSet()');
                this.$refs.trainingSetForm.saveTrainingSet();
            },
            finishEditing() {
                this.debug('finishEditing()');
                this.showForm = false;
                this.$refs.trainingSetList.loadTrainingSets();
            },
            debug(message) {
                console.log('TrainingSetsPage: ' + message);
            },

        }
    }
</script>